import axios from 'axios';

const api = axios.create({
   //baseURL: "http://192.168.29.250:7000/"
baseURL: "https://admin-service.swasthyakhata.com/"
});

export default api;